export const receipts = {
    header: {
        title: 'Importar comprovante',
    },
    actions: {
        gallery: {
            title: 'Galeria',
            subtitle: 'Screenshot ou foto',
        },
        camera: {
            title: 'Câmera',
            subtitle: 'Tirar foto',
        },
        pdf: {
            title: 'PDF',
            subtitle: 'Arquivo bancário',
        },
    },
    scanning: {
        title: 'Processando comprovante...',
        subtitlePdf: 'Lendo texto do PDF',
        subtitleImage: 'Extraindo texto com OCR',
    },
    preview: {
        pdfFallback: 'PDF importado',
    },
    result: {
        bankLabel: 'Banco',
        amountLabel: 'Valor',
        amountValue: 'R$ {{value}}',
        typeLabel: 'Tipo',
        descriptionLabel: 'Descrição',
        scanAnother: 'Escanear outro comprovante',
        goHome: 'Voltar ao início',
        pendingHint: 'A pendência ficou salva no início, é só confirmar quando quiser.',
    },
    fallbackDescription: {
        generic: 'Comprovante importado',
        withBank: 'Comprovante {{bank}}',
    },
    error: {
        title: 'Não foi possível processar',
        tryAgain: 'Tentar novamente',
        processFallback: 'Erro ao processar comprovante',
    },
    notIdentified: {
        title: 'Comprovante não identificado',
        messagePdf: 'Não foi possível extrair o valor deste PDF.',
        messageImage: 'Não foi possível extrair o valor deste comprovante. Tente com uma imagem mais nítida.',
    },
    permission: {
        title: 'Permissão necessária',
        message: 'Permita o acesso à câmera para tirar foto do comprovante.',
    },
    toast: {
        errorTitle: 'Erro ao processar',
        errorFallback: 'Tente novamente.',
    },
    okButton: 'OK',
};
